<template>

  <div v-if="admin_user">
    <h1>Admin User: {{ admin_user.name }}</h1>
    <div class="box">
      <Errors/>
      <form class="form" v-on:submit.prevent="updateAdminUser">
        <AdminUserFields />
        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled>Creating...</button>
          </div>
          <div v-else>
            <button type="submit" class="button">Update admin user</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AdminUserFields from '@/components/AdminUser/AdminUserFields.vue'
import Errors from '@/components/Errors.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'AdminUserEdit',
  components: {
    AdminUserFields,
    Errors
  },
  data () {
    return {
      admin_user: {
        flag: 'edit',
        admin_user_id :this.$route.params.id
      },
    }
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
  },
  created () {
    this.getAdminUser()
  },
  watch: {
    '$route': 'getAdminUser'
  },
  methods: {
    getAdminUser () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'admin-users/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
        .then(response => {
        if (response.status) {
          this.admin_user = response.data
          this.admin_user.flag = 'edit'
          this.admin_user.admin_user_id = response.data.id
        }
        this.$store.dispatch('setLoadStatus')
      })
    },
    updateAdminUser () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'admin-users/handle-user', {
        method: 'POST',
        body: JSON.stringify(this.admin_user),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.status) {
          this.$notify({
            type: 'success',
            title: response.message
          });
          this.$router.push({ name: 'admin-user-index' })

        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
  }
}
</script>
